export const WWW_ROUTES = {
  SERVICE_WAREHOUSE_STORAGE: '/services/storage/warehouse-storage',
  SERVICE_MOVING: '/services/moving',
  SERVICE_STORAGE_AND_MOVING: '/services/moving/with-storage',
  SERVICE_APARTMENT_MOVING: '/services/apartment-moving',
  PRODUCT_PAGE_STORAGE: '/book/storage',
  PRODUCT_PAGE_MOVING: '/book/moving',
  STORAGE_CART: '/book/storage/cart',
  MOVING_CART: '/book/moving/cart',
} as const;
